"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _trackers = require("../../trackers");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var generatePulseExperimentObjects = function generatePulseExperimentObjects(platform, features) {
  return features.map(function (key) {
    return {
      id: key,
      variant: 'default',
      name: key,
      // Undocumented schema field, required by the Pulse SDK.
      platform: platform
    };
  });
};

var Experiments = function Experiments(_ref) {
  var _ref$enabledOptimizel = _ref.enabledOptimizelyFeatures,
      enabledOptimizelyFeatures = _ref$enabledOptimizel === void 0 ? [] : _ref$enabledOptimizel,
      _ref$enabledUnleashFe = _ref.enabledUnleashFeatures,
      enabledUnleashFeatures = _ref$enabledUnleashFe === void 0 ? [] : _ref$enabledUnleashFe;
  (0, _react.useEffect)(function () {
    _trackers.pulse.update({
      experiments: [].concat(_toConsumableArray(generatePulseExperimentObjects('optimizely', enabledOptimizelyFeatures)), _toConsumableArray(generatePulseExperimentObjects('unleash', enabledUnleashFeatures)))
    });

    _trackers.gtm.update({
      enabledExperiments: [].concat(_toConsumableArray(enabledOptimizelyFeatures), _toConsumableArray(enabledUnleashFeatures))
    });
  }, [enabledOptimizelyFeatures, enabledUnleashFeatures]);
  return null;
};

Experiments.proptTypes = {
  platform: _propTypes["default"].string.isRequired,
  enabledOptimizelyFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string),
  enabledUnleashFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = Experiments;
exports["default"] = _default;
//# sourceMappingURL=Experiments.js.map